__turbopack_context__.v({
  "container": "Dropdown-module-scss-module__cw76_q__container",
  "dropdownItem": "Dropdown-module-scss-module__cw76_q__dropdownItem",
  "fadeInUp": "Dropdown-module-scss-module__cw76_q__fadeInUp",
  "popup": "Dropdown-module-scss-module__cw76_q__popup",
  "selected": "Dropdown-module-scss-module__cw76_q__selected",
  "toggle": "Dropdown-module-scss-module__cw76_q__toggle",
  "topEndPlacement": "Dropdown-module-scss-module__cw76_q__topEndPlacement",
  "topStartPlacement": "Dropdown-module-scss-module__cw76_q__topStartPlacement",
});
